export default __webpack_public_path__ + "static/media/vtyre.07f65d74.png";